import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react';
import {
  PersonRecord,
  PersonRecordPreInfo,
} from '../../../../redux/Candidate/Record/Record.type';
import BaseModalComponent from '../../BaseModal.component';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { DATE_TIME_FORMAT } from '../../../../constants/date.contant';
import { useTheme } from 'styled-components';
import SpinnerComponent from '../../../Spinner.component';
import { useAppDispatch } from '../../../../hooks/useAppDispatcher.hook';
import { useAppSelector } from '../../../../hooks/useAppSelector.hook';
import TextareaComponent from '../../../Input/Textarea.component';
import FormLayoutComponent from '../../../Form/FormLayout.component';
import ButtonComponent from '../../../Button.component';
import {
  createPersonRecordThunk,
  getCandidateRecordInfoThunk,
  updatePersonRecordThunk,
} from '../../../../redux/Candidate/Record/Record.thunk';
import {
  getCandidateRecordInfo,
  resetCandidateRecordInfoAction,
} from '../../../../redux/Candidate/Record/Record.slice';
import InputComponent from '../../../Input/Input.component';
import { Transition } from 'react-transition-group';
import DatepickerModalComponent from '../../DatepickerModal.component';
import SelectComponent, {
  SelectGroupedOption,
  SelectOptionProps,
} from '../../../Input/Select.component';
import { Job } from '../../../../redux/Job/Job.type';
import { getJobListThunk } from '../../../../redux/Job/Job.thunk';
import { getSourceListThunk } from '../../../../redux/Source/Source.thunk';
import { getRegionListThunk } from '../../../../redux/Region/Region.thunk';
import { Region } from '../../../../redux/Region/Region.type';
import { getDepartmentListThunk } from '../../../../redux/Department/Department.thunk';
import { Department } from '../../../../redux/Department/Department.type';
import CardComponent from '../../../Card.component';
import ModalAttachBlockComponent from '../../../Blocks/ModalAttachBlock.component';
import { Person } from '../../../../redux/Candidate/Candidate.type';
import UserBadgeComponent from '../../../UserBadge.component';
import { getAttachmentListThunk } from '../../../../redux/Attachment/Attachment.thunk';
import {
  getAttachmentsList,
  resetAttachmentListAction,
} from '../../../../redux/Attachment/Attachment.slice';
import { useModalManager } from '../../../../hooks/ModalManager.hook';
import {
  createPersonThunk,
  getCandidateMergeWithDataThunk,
} from '../../../../redux/Candidate/Candidate.thunk';
import ApiWrapper from '../../../../hooks/useApi.hook';
import { RoutesConstant } from '../../../../constants/routes.constant';
import { useLocation, useNavigate } from 'react-router-dom';
import { getGlobalRegionSelected } from '../../../../redux/Region/Region.slice';
import useAuthHook from '../../../../hooks/useAuth.hook';
import { checkUserRequiredPermissions } from '../../../../utils/getUserRolesByToken';
import { UserPermissions } from '../../../../types/userPermissions.types';
import { getUrlBasedOnCurrentPath } from '../utils';
import { getInternshipSelected } from '../../../../redux/Internship/Internship.slice';
import {
  addInternshipCandidateThunk,
  getInternshipInfoThunk,
  getInternshipPeopleListThunk,
} from '../../../../redux/Internship/Internship.thunk';
import TagBlock from '../../../Blocks/TagBlock';
import useStatusHook from '../../../../hooks/useStatus.hook';
import {
  getCandidateSelected,
  resetCandidateSelectedAction,
} from '../../../../redux/Candidate/Candidate.slice';
import { textAriasMaxLength } from '../../../../constants/textArias.constant';
import { Source } from '../../../../redux/Source/Source.type';
import ReplyToCandidateModal, {
  GOOGLE_CALENDAR_EVENT_WHEN_STATUSES,
  REPLY_WHEN_STATUSES,
} from '../../ReplyToCandidateModal.component';
import GoogleCalendarEventModalComponent from '../../Calendar/GoogleCalendarEventModal.component';
import EmployeeSelect from '../../../Input/EmployeeSelect.component';
import HRSelect from '../../../Input/HRSelect.component';
import RecruiterSelect from '../../../Input/RecruiterSelect.component';
import {
  StyledSelectOption,
  StyledSelectOptionDescription,
  StyledCandidateEditModalFooter,
  StyledStatusGroup,
  StyledCandidateEditModalStack,
  StyledAttachModal,
  StyledCandidateEditModal,
} from './styledComponents';
import useFormHook, { numbersOnlyFilter } from '../../../../hooks/useForm.hook';
import {
  maxLength,
  regExp,
  required,
  validateIf,
} from '../../../../services/validator.service';
import { RecordTypes } from '../../../../types/record.types';
import { REGEXP, SPACES_REGEXP } from '../../../../constants/regexp.constant';
import { setDispatchModal } from '../../../../redux/App/App.slice';
import {
  deleteLocalStorage,
  getLocalStorage,
  setLocalStorage,
} from '../../../../utils/storage';
import { AttachEditState } from '../../../../redux/Attachment/Attachment.type';

export interface CandidateEditModalProps
  extends React.AllHTMLAttributes<HTMLDivElement> {
  info?: PersonRecord;
  preInfo?: PersonRecordPreInfo;
  isUnmergeDuplicate?: boolean;
  onClose?: () => void;
  onSaved?: () => void;
  isEditCandidatePersonalCard?: boolean;
  isNewCandidate?: boolean;
  needAllStatuses?: boolean;
}

interface SelectSourceProps extends SelectOptionProps {
  code: string;
}

const hrRequiredEventIds = [4, 5, 7];
const optionalSalaryEventIds = [1, 2];

const recommendationCode = 'REKOMENDACIIA';

export const copySalary = (event: React.ClipboardEvent) => {
  event.preventDefault();

  // Преобразуем '3 500 000' к '3500000'
  if (event.clipboardData) {
    const selectedText = window.getSelection()?.toString() || '';

    event.clipboardData.setData(
      'text',
      selectedText.replace(SPACES_REGEXP, ''),
    );
  }
};

const RecordEditModalComponent = ({
  preInfo,
  info,
  isUnmergeDuplicate,
  isEditCandidatePersonalCard,
  onSaved,
  isNewCandidate,
  needAllStatuses,
}: CandidateEditModalProps) => {
  const theme = useTheme() as any;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useAuthHook();
  const record = useAppSelector(getCandidateRecordInfo);
  const globalRegion = useAppSelector(getGlobalRegionSelected);
  const attachments = useAppSelector(getAttachmentsList);
  const { item: selectedInternship } = useAppSelector(getInternshipSelected);
  const { closeModal, closeAllModals, openModal } = useModalManager();
  const { getSelectWholeList: getStatusList, getGroupIdByItemId } =
    useStatusHook();
  const formCandidate = useAppSelector(getCandidateSelected);
  const [referralRequired, setReferralRequired] = useState<boolean>(false);

  let savedEntity = 'newRecord';
  let savedPersonEntity = 'editPersonL';

  if (info?.personId) {
    savedEntity = `newRecord-${info?.personId}`;
  }
  if (window.location.origin.includes('linkedin')) {
    const person = window.location.pathname.split('/')[2];
    savedEntity = `editRecordL-${person}`;
    savedPersonEntity = `editPersonL-${person}`;
  }
  if (isEditCandidatePersonalCard) {
    savedEntity = `editRecord-${record?.item?.id}`;
  }

  const isLinkedin = window.location.origin.includes('linkedin');

  const savedData = getLocalStorage(savedEntity) || '';
  const parsedSavedData = savedData ? JSON.parse(savedData) : {};

  const { form, registerField, setFormValue, handleFormChange, validate } =
    useFormHook({
      date: 0,
      status: undefined,
      source: undefined,
      jobs: [],
      hr: undefined,
      recruiter: undefined,
      techSpecialists: [],
      referral: undefined,
      region: undefined,
      department: undefined,
      salary: null,
      salaryBrutto: null,
      comment: '',
      attachments: undefined,
      tags: [],
    });

  useEffect(() => {
    if (preInfo) {
      dispatch(
        getCandidateRecordInfoThunk({
          personId: preInfo!.personId,
          recordId: preInfo!.id,
        }),
      );

      dispatch(
        getAttachmentListThunk({
          object: 'PERSON_RECORD',
          objectId: preInfo!.id,
        }),
      );
    }

    if (info) {
      if (info!.id) {
        dispatch(
          getAttachmentListThunk({
            object: 'PERSON_RECORD',
            objectId: info!.id,
          }),
        );
      }
    }

    return () => {
      dispatch(resetCandidateRecordInfoAction(undefined));
      dispatch(resetAttachmentListAction(undefined));
    };
  }, [dispatch]);

  const eventIDByStatus = useMemo(() => {
    if (form.status && form.status.value) {
      return Number(getGroupIdByItemId(Number(form.status.value)));
    } else return;
  }, [form.status]);

  useEffect(() => {
    if (!record || !record.item) return;
    const { item } = record;

    const date = parsedSavedData.date || item?.date;
    const status = parsedSavedData.status || item?.status;
    const source = parsedSavedData.source || item?.source;
    const salary = parsedSavedData?.salary || item?.salary;
    const salaryBrutto = parsedSavedData?.salaryBrutto || item?.salaryBrutto;
    const comment = parsedSavedData?.comment || item?.comment || '';
    const hr = parsedSavedData.hr || item?.hr;
    const recruiter = parsedSavedData.recruiter || item?.recruiter;
    const techSpecialists =
      parsedSavedData?.techSpecialists || item?.techSpecialists || [];
    const referral = parsedSavedData.referral || item?.referral;
    const region = parsedSavedData.region || item?.region;
    const department = parsedSavedData.department || item?.department;
    const tags = parsedSavedData?.tags || item?.tags || [];
    const jobs = parsedSavedData?.jobs || item?.jobs || [];
    const attachments = parsedSavedData?.attachments || item?.attachments || [];

    if (source?.code === recommendationCode) setReferralRequired(true);

    const newForm = {
      date: date * 1000,
      status: status && {
        value: status.id,
        label: status.name,
      },
      source: source && {
        value: source.id,
        label: source.name,
      },
      jobs: jobs.map((job: Job) => {
        return {
          value: job.id,
          label: job.name,
        };
      }),
      hr: hr && {
        value: hr.id,
        label: (
          <StyledSelectOption>
            <UserBadgeComponent info={hr} />
          </StyledSelectOption>
        ),
      },
      recruiter: recruiter && {
        value: recruiter.id,
        label: (
          <StyledSelectOption>
            <UserBadgeComponent info={recruiter} />
          </StyledSelectOption>
        ),
      },
      techSpecialists: techSpecialists
        ? (Array.isArray(techSpecialists)
            ? techSpecialists
            : [techSpecialists]
          ).map((ts: any) => ({
            value: ts.id,
            label: (
              <StyledSelectOption>
                <UserBadgeComponent info={ts} />
              </StyledSelectOption>
            ),
          }))
        : [],
      referral: referral && {
        value: referral.id,
        label: (
          <StyledSelectOption>
            <UserBadgeComponent info={referral} />
          </StyledSelectOption>
        ),
      },
      region: region && {
        value: region.id,
        label: region.name,
      },
      department: department && {
        value: department.id,
        label: (
          <StyledSelectOption>
            <div>{department.name}</div>
          </StyledSelectOption>
        ),
      },
      salary: salary,
      salaryBrutto: salaryBrutto,
      comment: comment || '',
      attachments: attachments || undefined,
      tags: [...tags],
    };

    setFormValue(newForm);
  }, [record]);

  useEffect(() => {
    const status = parsedSavedData.status || info?.status;
    const source = parsedSavedData.source || info?.source;
    const salary = parsedSavedData?.salary || info?.salary;
    const salaryBrutto = parsedSavedData?.salaryBrutto || info?.salaryBrutto;
    const comment = parsedSavedData?.comment || info?.comment || '';
    const hr = parsedSavedData.hr || info?.hr;
    const recruiter = parsedSavedData.recruiter || info?.recruiter;
    const techSpecialists =
      parsedSavedData?.techSpecialists || info?.techSpecialists || [];
    const referral = parsedSavedData.referral || info?.referral;
    const region = parsedSavedData.region || info?.region;
    const department = parsedSavedData.department || info?.department;
    const tags = parsedSavedData?.tags || info?.tags || [];
    const jobs = parsedSavedData?.jobs || info?.jobs || [];
    const attachments = parsedSavedData?.attachments || info?.attachments || [];

    if (info) {
      const newForm = {
        date: parsedSavedData?.date || dayjs().unix() * 1000,
        status: status && {
          value: status.id,
          label: status.name,
        },
        source: isLinkedin
          ? {
              value: 1,
              label: 'LinkedIN',
            }
          : source && {
              value: source.id,
              label: source.name,
            },
        jobs: jobs
          ? jobs.map((job: Job) => {
              return {
                value: job.id,
                label: job.name,
              };
            })
          : [],
        hr: hr
          ? {
              value: hr.id,
              label: (
                <StyledSelectOption>
                  <UserBadgeComponent info={hr} />
                </StyledSelectOption>
              ),
            }
          : undefined,
        recruiter: recruiter
          ? {
              value: recruiter.id,
              label: (
                <StyledSelectOption>
                  <UserBadgeComponent info={recruiter} />
                </StyledSelectOption>
              ),
            }
          : user && user.id
          ? {
              value: user.id!,
              label: (
                <StyledSelectOption>
                  <UserBadgeComponent info={user} />
                </StyledSelectOption>
              ),
            }
          : undefined,
        techSpecialists: techSpecialists
          ? (Array.isArray(techSpecialists)
              ? techSpecialists
              : [techSpecialists]
            ).map((ts: any) => ({
              value: ts.id,
              label: (
                <StyledSelectOption>
                  <UserBadgeComponent info={ts} />
                </StyledSelectOption>
              ),
            }))
          : [],
        referral: referral && {
          value: referral.id,
          label: (
            <StyledSelectOption>
              <UserBadgeComponent info={referral} />
            </StyledSelectOption>
          ),
          available: referral.available,
        },
        region: region
          ? {
              value: region.id,
              label: region.name,
            }
          : globalRegion,
        department: department && {
          value: department.id,
          label: (
            <StyledSelectOption>
              <div>{department.name}</div>
            </StyledSelectOption>
          ),
        },
        salary,
        salaryBrutto,
        comment,
        attachments: attachments
          ? attachments?.map((attach: AttachEditState) => ({
              ...attach,
              tmpUUID: attach.uuid,
              uuid: undefined,
              author_id: attach.author ? attach.author.id : attach.author_id,
            }))
          : [],
        tags,
      };
      setFormValue(newForm);
    }
  }, [info, record, globalRegion]);

  useEffect(() => {
    if (parsedSavedData.attachments && parsedSavedData.attachments.length > 0) {
      handleFormChange({ attachments: parsedSavedData.attachments });
      handleFormSave({ attachments: parsedSavedData.attachments });
      return;
    }

    if (!attachments) return;

    const item =
      (info ? (info.originalId ? info.originalId : info.id) : undefined) ||
      (record && record.item ? record.item.id : undefined);

    if (!item) return;

    const attachmentsMapped = attachments.items[item]
      ? attachments.items[item].map((attach: any) => ({
          ...attach,
          uuid:
            (info && info.id) || (record.item && record.item.id)
              ? attach.uuid
              : undefined,
          tmpUUID: attach.uuid,
          author_id: attach.author ? attach.author.id : attach.author_id,
        }))
      : [];

    handleFormChange({ attachments: attachmentsMapped });
    handleFormSave({ attachments: attachmentsMapped });
  }, [info, record, attachments]);

  useLayoutEffect(() => {
    const salary = form.salary;
    const salaryBrutto = form.salaryBrutto;

    const isRequired = !optionalSalaryEventIds.includes(
      eventIDByStatus || getterEventId,
    );

    if (!form.region?.label) return;

    if (form.region?.label?.includes('Lambda')) {
      handleFormChange({ salary: null }, { validations: [] });
      handleFormSave({ salary: null });

      handleFormChange(
        { salaryBrutto: salaryBrutto || salary },
        {
          validations: isRequired
            ? [regExp(REGEXP.NUMBERS_ONLY), maxLength(9), required]
            : [regExp(REGEXP.NUMBERS_ONLY), maxLength(9)],
        },
      );
      handleFormSave({ salaryBrutto: salaryBrutto || salary });
    } else {
      handleFormChange(
        { salary: salary || salaryBrutto },
        {
          validations: isRequired
            ? [regExp(REGEXP.NUMBERS_ONLY), maxLength(9), required]
            : [regExp(REGEXP.NUMBERS_ONLY), maxLength(9)],
        },
      );
      handleFormSave({ salary: salary || salaryBrutto });

      handleFormChange({ salaryBrutto: null }, { validations: [] });
      handleFormSave({ salaryBrutto: null });
    }
  }, [form.region]);

  const openReplyToCandidateModal = async (savedRecord?: {
    personId?: number | string;
    recordId?: number | string;
  }) => {
    if (
      form.status &&
      GOOGLE_CALENDAR_EVENT_WHEN_STATUSES.includes(form.status?.code || '') &&
      form.status?.hasPlanningTime &&
      checkUserRequiredPermissions(user.permissions, [
        UserPermissions.CAN_CREATE_GOOGLE_MEET_INTERVIEW,
      ]) &&
      record.item?.status?.code !== form.status?.code
    ) {
      const candidate = formCandidate.item;
      const personId =
        savedRecord?.personId || info?.personId || record.item?.personId;
      const recordId =
        savedRecord?.recordId || record.item?.id || info?.id;
      let calendarRecord: PersonRecord | undefined = record.item || info;

      if (personId && recordId) {
        try {
          const freshRecord = await dispatch(
            getCandidateRecordInfoThunk({
              personId,
              recordId,
            }),
          ).unwrap();
          if (freshRecord) {
            calendarRecord = freshRecord;
          }
        } catch (e) {
          console.error(e);
        }
      }

      if (!calendarRecord) return;

      openModal(GoogleCalendarEventModalComponent, {
        eventStatusCode: form.status?.code,
        record: calendarRecord,
        candidateName: candidate?.fullName,
        candidateEmail: candidate?.email,
        candidateAttachments: candidate?.attachments,
      });
      return;
    }

    if (
      form.status &&
      REPLY_WHEN_STATUSES.includes(form.status?.code || '') &&
      record.item.status.code !== form.status?.code
    ) {
      openModal(ReplyToCandidateModal, {
        status: form.status,
      });
      return;
    }
  };

  const renderHeader = useMemo(() => {
    if (!record.item) return t('New record');
    const { item } = record;
    return `${item.status ? item.status.event.name : t('Edit record')} ${dayjs(
      (item.date || item.createdAt) * 1000,
    ).format(DATE_TIME_FORMAT)}`;
  }, [record]);

  const saveRecordResult = useCallback(
    async (info: any) => {
      if (!info) return;

      let thunkApi: any = createPersonRecordThunk;

      if (info.id) {
        thunkApi = updatePersonRecordThunk;
      }

      const res = await ApiWrapper(
        thunkApi({
          personId: info!.personId,
          recordId: info.id || undefined,
          date: form.date && form.date / 1000,
          jobsId: form.jobs.map((job: SelectOptionProps) => job.value),
          statusId: form.status && form.status.value,
          sourceId: form.source && form.source.value,
          hrId: form.hr && form.hr.value,
          recruiterId: form.recruiter && form.recruiter.value,
          techSpecialistsId: form.techSpecialists.map((ts: any) => ts.value),
          referralId: form.referral && form.referral.value,
          regionId: form.region && form.region.value,
          departmentId: form.department && form.department.value,
          salary: form.salary || null,
          salaryBrutto: form.salaryBrutto || null,
          comment: form.comment,
          attachments: form.attachments,
          tags: form.tags,
        }),
      );

      if (!res) return;

      if (window.location.origin.includes('linkedin')) {
        dispatch(resetCandidateSelectedAction(undefined));
        dispatch(setDispatchModal(undefined));
        window.open(
          `${process.env.REACT_APP_API_URL}/candidates/all/candidate/${
            info!.personId
          }`,
          '_blank',
          'noopener,noreferrer',
        );

        onSaved && onSaved();
        closeAllModals();

        return;
      }

      const personUrl = getUrlBasedOnCurrentPath(location, info!.personId, [
        RoutesConstant.CANDIDATE,
        RoutesConstant.CANDIDATES_GROUP,
      ]);

      !!personUrl && navigate(personUrl);
      closeAllModals();

      openReplyToCandidateModal({
        personId: info.personId,
        recordId: info.id || res?.id,
      });
    },
    [form],
  );

  const savePersonResult = () => {
    ApiWrapper(
      createPersonThunk({
        ...formCandidate.item,
        hasSoftSearch: false,
      }),
    ).then((res: Person) => {
      saveRecordResult({
        ...formCandidate.item,
        personId: res.id,
      });
      appendToInternship(res);
      deleteLocalStorage(savedEntity);
      if (isNewCandidate) deleteLocalStorage('newPerson');
    });
  };

  const appendToInternship = (res: Person) => {
    if (selectedInternship) {
      ApiWrapper(
        addInternshipCandidateThunk({
          id: selectedInternship.id,
          payload: res,
        }),
      ).then(() => {
        dispatch(getInternshipPeopleListThunk({ id: selectedInternship.id }));
        dispatch(getInternshipInfoThunk(selectedInternship.id));
      });
    }
  };

  const onSaveResult = () => {
    if (!validate()) return;

    if (isEditCandidatePersonalCard) {
      deleteLocalStorage(savedEntity);
      return saveRecordResult(info || record.item);
    }

    if (isUnmergeDuplicate) {
      return savePersonResult();
    }

    if (isUnmergeDuplicate !== undefined) {
      ApiWrapper(
        getCandidateMergeWithDataThunk({
          ...formCandidate.item,
          id: info?.personId,
          links: info?.tmpPerson.links,
          tags: formCandidate.item.tags.map(
            (item: { id: number; name: string }) => item.id,
          ),
        }),
      ).then(() => {
        saveRecordResult(info || record.item);
        deleteLocalStorage(savedEntity);
        if (isNewCandidate) deleteLocalStorage('newPerson');
        if (isLinkedin) deleteLocalStorage(savedPersonEntity);
      });
    } else {
      saveRecordResult(info || record.item);
      deleteLocalStorage(savedEntity);
      if (isNewCandidate) deleteLocalStorage('newPerson');
    }
  };

  const onCloseModal = () => {
    closeModal();
    deleteLocalStorage(savedEntity);
  };

  const jobsLoadOptions = useCallback(
    async (search: string, loadedOptions: string | any[], { page }: any) => {
      const {
        payload: { data, pagination },
      } = await dispatch(getJobListThunk({ search, page }));
      return {
        options: data.map((item: Job) => ({
          value: item.id,
          label: item.name,
        })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },
    [],
  );

  const sourceLoadOptions = useCallback(
    async (search: string, loadedOptions: string | any[], { page }: any) => {
      const {
        payload: { data, pagination },
      } = await dispatch(getSourceListThunk({ q: search, page }));

      return {
        options: data.map(({ id, name, code }: Source) => ({
          value: id,
          label: name,
          code,
        })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },
    [],
  );

  const regionListLoadOptions = useCallback(
    async (search: string, loadedOptions: string | any[], { page }: any) => {
      const {
        payload: { data, pagination },
      } = await dispatch(getRegionListThunk({ page, search }));

      const regionIdsUseraHasAccessTo = user.regions.map(
        (region: { id: any }) => region.id,
      );
      return {
        options: data
          .filter((item: Region) => regionIdsUseraHasAccessTo.includes(item.id))
          .map((item: Region) => ({
            value: item.id,
            label: item.name,
          })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },
    [],
  );

  const departmentListLoadOptions = useCallback(
    async (search: string, loadedOptions: string | any[], { page }: any) => {
      const {
        payload: { data, pagination },
      } = await dispatch(getDepartmentListThunk({ page, search }));
      return {
        options: data.map((item: Department) => ({
          value: item.id,
          label: item.name,
        })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },
    [],
  );

  const getterEventId = useMemo(() => {
    if (!info && !record.item) return;

    if (record.item) {
      return record.item.status?.event.id;
    }
    return info!.status?.event.id;
  }, [record, info, preInfo]);

  const renderFooter = useMemo(() => {
    return (
      <StyledCandidateEditModalFooter>
        <ButtonComponent
          appearance="primary"
          disabled={false}
          handleClick={onSaveResult}
        >
          {t('Next')}
        </ButtonComponent>
        <ButtonComponent handleClick={onCloseModal}>
          {t('Cancel')}
        </ButtonComponent>
      </StyledCandidateEditModalFooter>
    );
  }, [form]);

  const formatStatusGroupLabel = (data: SelectGroupedOption) => (
    <StyledStatusGroup>
      <span>{data.label}</span>
    </StyledStatusGroup>
  );

  const isTechSpecialistDropdownDisabled =
    record.item &&
    record.item.status.event.code === RecordTypes.INTERNSHIP_GROUP;

  const statusLoadOptions = async (
    search: string,
    loadedOptions: string | any[],
    { eventId, page }: any,
  ) => {
    return await getStatusList(search, loadedOptions, {
      eventId: needAllStatuses
        ? ''
        : record.item?.status.event.code === RecordTypes.INTERNSHIP_GROUP
        ? record?.item?.status?.event.id
        : eventId,
      page: needAllStatuses ? '' : page,
    });
  };

  const handleFormSave = (data: { [key: string]: any }) => {
    const attrKey = Object.keys(data)[0];
    const attrValue = Object.values(data)[0];

    let savedEntity = 'newRecord';
    if (info?.personId) {
      savedEntity = `newRecord-${info?.personId}`;
    }
    if (window.location.origin.includes('linkedin')) {
      const person = window.location.pathname.split('/')[2];
      savedEntity = `editRecordL-${person}`;
    }
    if (isEditCandidatePersonalCard) {
      savedEntity = `editRecord-${record?.item?.id}`;
    }

    const savedData = getLocalStorage(savedEntity) || '';
    const parsedSavedData = savedData ? JSON.parse(savedData) : {};

    if (!attrValue) {
      delete parsedSavedData[attrKey];
      setLocalStorage(savedEntity, JSON.stringify({ ...parsedSavedData }));
      return;
    }

    let value = {
      id: attrValue?.value,
      name: attrValue?.label,
      code: attrValue?.code,
    };

    if (['hr', 'recruiter', 'referral'].includes(attrKey)) {
      delete value.name;
      delete value.code;
      value = {
        ...value,
        ...attrValue?.label.props.children.props.info,
      };
    }

    if (
      [
        'tags',
        'attachments',
        'date',
        'salary',
        'salaryBrutto',
        'comment',
      ].includes(attrKey)
    ) {
      value = attrValue;
    }

    if (['jobs'].includes(attrKey)) {
      value = attrValue?.map((item: { value: number; label: string }) => ({
        id: item.value,
        name: item.label,
      }));
    }

    if (['techSpecialists'].includes(attrKey)) {
      value = attrValue?.map((item: any) => ({
        id: item.value,
        avatar: item.label?.props?.children?.props?.info?.avatar,
        fullName: item.label?.props?.children?.props?.info?.fullName,
        full_name: item.label?.props?.children?.props?.info?.full_name,
        email: item.label?.props?.children?.props?.info?.email,
      }));
    }

    const newData = JSON.stringify({
      ...parsedSavedData,
      [attrKey]: value,
    });

    if (newData) setLocalStorage(savedEntity, newData);
  };

  const renderContent = useMemo(
    () => (
      <FormLayoutComponent>
        <StyledCandidateEditModalStack>
          <InputComponent
            {...registerField('date')}
            value={dayjs(form.date).format(DATE_TIME_FORMAT)}
            label={t('Date')}
            onClick={() =>
              openModal(DatepickerModalComponent, {
                defaultDate: form.date ? form.date : dayjs().unix(),
                handleChange: (date: number) => {
                  handleFormChange({ date });
                  handleFormSave({ date });
                },
              })
            }
          />

          <SelectComponent
            {...registerField('status', {
              validations: [required],
            })}
            value={form.status}
            label={t('Status') + '*'}
            placeholder={t('Choose status')}
            formatGroupLabel={formatStatusGroupLabel}
            loadOptions={statusLoadOptions}
            onChangeOption={(status: any) => {
              handleFormChange({ status });
              handleFormSave({ status });
            }}
            additional={{
              eventId: getterEventId,
            }}
          />

          <SelectComponent
            {...registerField('jobs', {
              validations: [required],
            })}
            value={form.jobs}
            label={t('Jobs') + '*'}
            placeholder={t('Choose job(-s)')}
            loadOptions={jobsLoadOptions}
            onChangeOption={(jobs: any) => {
              handleFormChange({ jobs });
              handleFormSave({ jobs });
            }}
            isOptionDisabled={form.jobs?.length >= 3}
            isMulti
          />

          {!form.region?.label?.includes('Lambda') && (
            <InputComponent
              {...registerField('salary', {
                validations: optionalSalaryEventIds.includes(
                  eventIDByStatus || getterEventId,
                )
                  ? [regExp(REGEXP.NUMBERS_ONLY), maxLength(9)]
                  : [regExp(REGEXP.NUMBERS_ONLY), maxLength(9), required],
                filters: [numbersOnlyFilter],
              })}
              value={
                form.salary?.length
                  ? parseInt(
                      form.salary.replace(/\s/g, '') || '',
                    ).toLocaleString('ru')
                  : ''
              }
              label={
                optionalSalaryEventIds.includes(
                  eventIDByStatus || getterEventId,
                )
                  ? t('Salary')
                  : t('Salary') + '*'
              }
              placeholder={t('Enter salary')}
              onChange={(salary: any) => {
                handleFormChange({ salary: salary.replace(/\s/g, '') });
                handleFormSave({ salary: salary.replace(/\s/g, '') });
              }}
              onClearClick={() => {
                handleFormChange({ salary: undefined });
                handleFormSave({ salary: undefined });
              }}
              onCopy={copySalary}
            />
          )}

          {form.region?.label?.includes('Lambda') && (
            <InputComponent
              {...registerField('salaryBrutto', {
                validations: optionalSalaryEventIds.includes(
                  eventIDByStatus || getterEventId,
                )
                  ? [regExp(REGEXP.NUMBERS_ONLY), maxLength(9)]
                  : [regExp(REGEXP.NUMBERS_ONLY), maxLength(9), required],
                filters: [numbersOnlyFilter],
              })}
              value={
                form.salaryBrutto?.length
                  ? parseInt(
                      form.salaryBrutto.replace(/\s/g, '') || '',
                    ).toLocaleString('ru')
                  : ''
              }
              label={
                optionalSalaryEventIds.includes(
                  eventIDByStatus || getterEventId,
                )
                  ? t('SalaryBrutto')
                  : t('SalaryBrutto') + '*'
              }
              placeholder={t('Enter salary')}
              onChange={(salaryBrutto: any) => {
                handleFormChange({
                  salaryBrutto: salaryBrutto.replace(/\s/g, ''),
                });
                handleFormSave({
                  salaryBrutto: salaryBrutto.replace(/\s/g, ''),
                });
              }}
              onClearClick={() => {
                handleFormChange({ salaryBrutto: null });
                handleFormSave({ salaryBrutto: null });
              }}
              onCopy={copySalary}
            />
          )}

          <SelectComponent
            {...registerField('source', {
              validations: [required],
            })}
            value={form.source}
            label={t('Source') + '*'}
            placeholder={t('Choose source')}
            loadOptions={sourceLoadOptions}
            onChangeOption={(value: SelectSourceProps) => {
              setReferralRequired(value?.code === recommendationCode);
              handleFormChange({ source: value });
              handleFormSave({ source: value });
            }}
          />

          <RecruiterSelect
            {...registerField('recruiter', {
              validations: [required],
            })}
            value={form.recruiter}
            isRequired
            onChange={(recruiter: any) => {
              handleFormChange({ recruiter });
              handleFormSave({ recruiter });
            }}
          />

          <HRSelect
            {...registerField('hr', {
              validations: [
                validateIf(
                  hrRequiredEventIds.includes(eventIDByStatus || getterEventId),
                  required,
                ),
              ],
            })}
            value={form.hr}
            isRequired={hrRequiredEventIds.includes(
              eventIDByStatus || getterEventId,
            )}
            onChange={(hr: any) => {
              handleFormChange({ hr });
              handleFormSave({ hr });
            }}
          />

          <EmployeeSelect
            {...registerField('techSpecialists')}
            value={form.techSpecialists}
            label={t('Tech specialist')}
            placeholder={t('Choose tech specialists')}
            tooltip={
              record?.item?.status?.event?.code === RecordTypes.INTERNSHIP_GROUP
                ? t('TechSpecialistEditableInInternship')
                : undefined
            }
            onChangeOption={(techSpecialists: any) => {
              handleFormChange({ techSpecialists });
              handleFormSave({ techSpecialists });
            }}
            disabled={isTechSpecialistDropdownDisabled}
            isMulti={true}
          />

          <EmployeeSelect
            {...registerField('referral', {
              validations: [validateIf(referralRequired, required)],
            })}
            value={form.referral}
            label={t('Referral') + (referralRequired ? '*' : '')}
            placeholder={t('Choose referral')}
            onChangeOption={(referral: any) => {
              handleFormChange({ referral });
              handleFormSave({ referral });
            }}
          />

          <SelectComponent
            {...registerField('region', {
              validations: [required],
            })}
            value={form.region}
            label={t('Region') + '*'}
            placeholder={t('Choose region')}
            loadOptions={regionListLoadOptions}
            onChangeOption={(region: any) => {
              handleFormChange({ region });
              handleFormSave({ region });
            }}
          />

          <SelectComponent
            {...registerField('department')}
            value={form.department}
            label={t('Department')}
            placeholder={t('Choose department')}
            loadOptions={departmentListLoadOptions}
            onChangeOption={(department: any) => {
              handleFormChange({ department });
              handleFormSave({ department });
            }}
          />

          <TagBlock
            {...registerField('tags')}
            value={form.tags}
            onTagsChange={(tags: any) => {
              handleFormChange({ tags });
              handleFormSave({ tags });
            }}
            label={t('Tags')}
          />
        </StyledCandidateEditModalStack>

        <TextareaComponent
          {...registerField('comment')}
          value={form.comment}
          maxLength={textAriasMaxLength.RECORD_COMMENT}
          showCounter={true}
          label={t('Comment')}
          onChange={(comment: any) => {
            handleFormChange({ comment });
            handleFormSave({ comment });
          }}
        />
      </FormLayoutComponent>
    ),
    [
      record,
      form,
      form.date,
      form.status,
      form.jobs,
      form.tags,
      form.hr,
      form.techSpecialists,
      form.referral,
    ],
  );

  const renderAttachContent = useMemo(() => {
    return (
      <StyledAttachModal>
        <CardComponent>
          {!attachments.loading ? (
            <ModalAttachBlockComponent
              {...registerField('attachments')}
              value={form.attachments || []}
              onChangeAttachments={(attachments: any) => {
                handleFormChange({ attachments });
                const attachmentsForSave =
                  attachments.filter((item: AttachEditState) => !item.file) ||
                  [];
                handleFormSave({ attachments: attachmentsForSave });
              }}
            />
          ) : (
            <SpinnerComponent />
          )}
        </CardComponent>
      </StyledAttachModal>
    );
  }, [attachments, form.attachments]);

  return (
    <StyledCandidateEditModal>
      <BaseModalComponent
        header={renderHeader}
        footer={renderFooter}
        rightBlock={renderAttachContent}
      >
        {renderContent}
        <Transition
          in={record.loading}
          mountOnEnter
          unmountOnExit
          timeout={{ exit: 300 }}
        >
          {state => (
            <SpinnerComponent
              style={{
                ...theme.animations.reverseDefaultState,
                ...theme.animations.defaultSteps[state],
              }}
            />
          )}
        </Transition>
      </BaseModalComponent>
    </StyledCandidateEditModal>
  );
};

export default RecordEditModalComponent;
